import { mapKeys, mapValues, sumBy, values } from 'lodash';
import ContractEnhancement from 'models/sales/contractEnhancement/Model.ContractEnhancement';

export const sumAllDistributions = (distributions?: Utils.PricingDistribution) =>
  sumBy(values(distributions), (d) => d.amount || 0);

export const sumAllNestedDistributions = (distributions?: Utils.PricingDistribution[]) =>
  sumBy(distributions, sumAllDistributions);

export const sumAllSurcharges = (surcharges?: Utils.SurchargeInfo[]) =>
  sumBy(surcharges, (f) => (f.amount || 0) * (f.quantity || 1));

export const displayCurrency = (amount: number, currency?: string) =>
  `${amount.toFixed(2)}${!currency || currency === 'CAD' ? '$' : currency}`;

export const displayDistributions = (distribution: Utils.PricingDistribution) =>
  mapValues(
    mapKeys(distribution, (_, key) => key.split('.').join(' - ')),
    (value) => displayCurrency(value.amount || 0, value.currency)
  );

export const getEnhancementName = (contractEnhancements: ContractEnhancement[], idx: number) =>
  contractEnhancements?.[idx]?.productEnhancement?.name || `Enhancement #${idx + 1}`;
